<template>
    <div>
        <kt-form-label>
            <h4>
                {{ $t('customers_club.setting.each_item_score') }}
            </h4>
        </kt-form-label>
        <kt-form-section class="mb-5 mt-3">
            <kt-row>
                <kt-col class="col-lg-6 col-md-6 col-sm-6">
                    <kt-form-group>
                        <kt-form-label for="profile_completed_percent">
                            {{ $t('customers_club.setting.profile_completed_percent') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="profile_completed_percent"
                                id="profile_completed_percent"
                                v-model="customers_club_setting.profile_completed_percent"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-6 col-md-6 col-sm-6">
                    <kt-form-group>
                        <kt-form-label for="transactions_number">
                            {{ $t('customers_club.setting.transactions_number') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="transactions_number"
                                id="transactions_number"
                                v-model="customers_club_setting.transactions_number"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col class="col-lg-6 col-md-6 col-sm-6">
                    <kt-form-group>
                        <kt-form-label for="total_transactions">
                            {{ $t('customers_club.setting.total_transactions') }}
                        </kt-form-label>
                        <kt-form-control
                                type="number"
                                name="total_transactions"
                                id="total_transactions"
                                v-model="customers_club_setting.total_transactions"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
                <kt-col class="col-lg-6 col-md-6 col-sm-6">
                    <kt-form-group>
                        <kt-form-label for="transaction_for_level_3">
                            {{ $t('customers_club.setting.shop_register') }}
                        </kt-form-label>
                        <kt-form-control
                                type="shop_register"
                                name="shop_register"
                                id="shop_register"
                                v-model="customers_club_setting.shop_register"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
            <kt-row>
                <kt-col class="col-lg-6 col-md-6 col-sm-6">
                    <kt-form-group>
                        <kt-form-label for="shop_order_register">
                            {{ $t('customers_club.setting.shop_order_register') }}
                        </kt-form-label>
                        <kt-form-control
                                type="shop_order_register"
                                name="shop_order_register"
                                id="shop_order_register"
                                v-model="customers_club_setting.shop_order_register"
                        >
                        </kt-form-control>
                    </kt-form-group>
                </kt-col>
            </kt-row>
        </kt-form-section>
    </div>
</template>

<script>
export default {
    name: "item-scores",
    props: {
        customers_club_setting: {
            required: true
        },
    },
}
</script>

<style scoped>

</style>